export class StatusFalseError extends Error {
    response: Response;

    constructor(response: Response) {
        super();
        this.name = 'StatusFalseError';
        this.message = 'status is FALSE';
        this.response = response;
    }
}
